module.exports = __webpack_public_path__ + "static/media/top-user-banner-2.10d02c74.jpg";